import { createMuiTheme } from '@material-ui/core';

const globalTheme = createMuiTheme({
  typography: {
    fontFamily: 'Roboto, sans-serif',
  },
});

export default globalTheme;
